import { Paper, Stack, Typography } from '@mui/material';

import { tCommon, tOrder } from '@frontend/locales';
import { OrderFilter } from '@frontend/utils';

import { FilterDisplayChip } from './filter-display-chip.component';
import { FilterPlaces } from './filter-places.component';
import { FilterStatus } from './filter-status.component';

export interface FilterDisplayProps {
  filter: OrderFilter;
}

export const FilterDisplay = ({ filter }: FilterDisplayProps) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        borderRadius: 0,
        p: 1,
        pl: 2,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <FilterDisplayChip label={tCommon.headers.places()}>
          <FilterPlaces placeIds={filter.placeIds} />
        </FilterDisplayChip>

        <FilterDisplayChip label={tOrder.headers.period()}>
          <Typography variant="caption">
            {tOrder.periodOptions[filter.period]!()}
          </Typography>
        </FilterDisplayChip>

        <FilterDisplayChip label={tCommon.headers.status()}>
          <FilterStatus statuses={filter.status} />
        </FilterDisplayChip>

        {filter.preOrder !== undefined && (
          <FilterDisplayChip label={tCommon.headers.preOrders()}>
            <Typography variant="caption">
              {tCommon.descriptions.xMinutesBefore({
                minutes: filter.preOrder.toString(),
              })}
            </Typography>
          </FilterDisplayChip>
        )}
      </Stack>
    </Paper>
  );
};
